<section class="my-templates-page">
  <div class="" [class.container-box]="viewType === 'list'">
    <div class="filters-box" [class.container-box]="viewType === 'grid'">
      <app-rental-select
        [inline]="true"
        i18n-matTooltip
        matTooltip="Only show automations that specify the selected rentals."
        [ctrl]="filters.get('rentals')"
        placeholder="Rentals"
        i18n-placeholder
      ></app-rental-select>
      <app-select-search
        matTooltip="Only show automations that specify the selected channels."
        i18n-matTooltip
        bindValue="id"
        bindLabel="label"
        [items]="automationFilters.channels$ | async"
        [ctrl]="filters.get('channels')"
        placeholder="Channels"
        i18n-placeholder
      ></app-select-search>
      <app-select-search
        *ngIf="type === types.Message"
        matTooltip="Only show automations that specify the selected templates."
        i18n-matTooltip
        bindValue="id"
        bindLabel="name"
        [items]="automationFilters.templates$ | async"
        [ctrl]="filters.get('templates')"
        placeholder="Templates"
        i18n-placeholder
      ></app-select-search>

      <app-select-search
        matTooltip="Only show automations that specify the selected events."
        i18n-matTooltip
        bindValue="event"
        bindLabel="title"
        [items]="automationFilters.events$ | async"
        [ctrl]="filters.get('events')"
        placeholder="Events"
        i18n-placeholder
      ></app-select-search>
      <mat-form-field2 [showLabel]="false">
        <mat-select
          matTooltip="Only show triggers with the selected status."
          i18n-matTooltip
          [formControl]="filters.get('status')"
          placeholder="Status"
          i18n-placeholder
        >
          <mat-option *ngFor="let status of automationFilters.statuses$ | async" [value]="status.key">
            {{ status.name }}
          </mat-option>
        </mat-select>
      </mat-form-field2>
      <app-cancel-filters
        [isFiltering]="filters | isFiltering"
        [filterControl]="filters"
        [searchCom]="search"
      ></app-cancel-filters>
      <button class="btn btn-secondary-primary" (click)="onRefresh()" matTooltip="Refresh List" i18n-matTooltip>
        <i class="far fa-sync"></i>
      </button>
      <div class="flex-fill"></div>
      <app-table-search (search)="onSearch($event)" [filterGroup]="filterGroup" #search></app-table-search>
      <app-automations-table-actions [table]="self" *ngIf="showActions"></app-automations-table-actions>
    </div>
    <ng-template [ngTemplateOutlet]="table" *ngIf="viewType === 'list'"></ng-template>
    <ng-template [ngTemplateOutlet]="grid" *ngIf="viewType === 'grid'"></ng-template>
    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" [isFiltering]="filters | isFiltering">
      <ng-content selector="[emptyContent]"></ng-content>
    </app-empty-table>
  </div>
</section>

<ng-template #grid>
  <app-automation-grid [items]="dataSource.filteredData" (edit)="onEdit($event)" class="mt-3"> </app-automation-grid>
</ng-template>

<ng-template #table>
  <div class="table-holder table-responsive">
    <table class="table table-default table-striped">
      <mat-table
        #table
        matSort
        matSortActive="lastupdate"
        matSortDirection="desc"
        [dataSource]="dataSource"
        [trackBy]="trackBy"
      >
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Created</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.created | epoch }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header="attributes.name" i18n>Name</mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.attributes?.name">
            <div class="text-truncate">
              {{ element.attributes?.name }}
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="event">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Event</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.event | eventName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="handler">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Action</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ (element.handler | eventHandler)?.title }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastupdate">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Last Triggered</mat-header-cell>
          <mat-cell *matCellDef="let element" class="text-center">
            <span [matTooltip]="element.lastupdate | epoch" matTooltipPosition="above">
              {{ element.lastupdate | epoch }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Status</mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <app-form-switch
              [disabled]="1 | isReadonlyRole"
              [id]="element.id"
              [inline]="true"
              [value]="element.status === 1"
              (valueChange)="onTogglePause(element)"
            ></app-form-switch>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>
            <app-table-column-manager
              tableId="automations"
              [displayedColumns]="displayedColumns"
              (columnsChanged)="displayedColumns = $event"
            ></app-table-column-manager>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
              <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li *ngIf="isEditable">
                  <button (click)="onEdit(element)" type="button">
                    <i class="fal fa-edit fa-fw"></i><ng-container i18n>Edit</ng-container>
                  </button>
                </li>
                <li *ngIf="isDuplicable">
                  <button (click)="onDuplicate(element)" type="button">
                    <i class="fal fa-copy"></i><ng-container i18n>Duplicate</ng-container>
                  </button>
                </li>

                <li>
                  <button (click)="onTogglePause(element)" type="button">
                    <ng-container *ngIf="element.status === 1">
                      <i class="fal fa-pause fa-fw"></i><ng-container i18n>Pause</ng-container>
                    </ng-container>
                    <ng-container *ngIf="element.status === 0">
                      <i class="fal fa-play fa-fw"></i><ng-container i18n>Resume</ng-container>
                    </ng-container>
                  </button>
                </li>
                <li>
                  <button *ngIf="element.archived === 0" (click)="onArchive(element)" type="button">
                    <i class="fal fa-archive fa-fw"></i><ng-container i18n>Archive</ng-container>
                  </button>
                  <button *ngIf="element.archived === 1" (click)="onUnArchive(element)" type="button">
                    <i class="fal fa-archive fa-fw"></i><ng-container i18n>Unarchive</ng-container>
                  </button>
                </li>
                <li>
                  <button (click)="onDelete(element)" type="button">
                    <i class="cs-icon cs-icon-trash fa-fw"></i><ng-container i18n>Delete</ng-container>
                  </button>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClick(row)" class="clickable"></mat-row>
      </mat-table>
      <mat-paginator2
        #paginator
        [pageSize]="10"
        [class.hidden]="isEmptyTable$ | async"
        [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>
    </table>
  </div>
</ng-template>
